import { useMemo } from 'react';
import Cookies from 'js-cookie';
import { getSsoUrl, getAgentLoginUrl, getTokenName, getSsoEnabled, getAgentLoginEnabled, } from '../utils/globals';
import { SSO_RETURN_URL_KEY } from '../utils/config';
const LOGOUT_URL = '/sso/logout';
export default function useAuth({ onlyShowLogin, agentLogin, } = {}) {
    const tokenName = getTokenName(window.cname, window.subdomain);
    const ssoToken = useMemo(() => Cookies.get(tokenName), [tokenName]);
    const isAgentLoginEnabled = getAgentLoginEnabled();
    const isLogingIn = !ssoToken || onlyShowLogin;
    let url;
    let handleClick;
    if (isLogingIn) {
        url = agentLogin && isAgentLoginEnabled ? getAgentLoginUrl() : getSsoUrl();
        handleClick = (e) => {
            e.preventDefault();
            Cookies.set(SSO_RETURN_URL_KEY, window.location.href);
            window.location.href = url;
        };
    }
    else {
        url = LOGOUT_URL;
        handleClick = (e) => {
            e.preventDefault();
            Cookies.remove(tokenName);
            window.location.href = LOGOUT_URL;
        };
    }
    return {
        url,
        ssoToken,
        handleClick,
        isSSOEnabled: getSsoEnabled(),
        isAgentLoginEnabled,
    };
}
//# sourceMappingURL=useAuth.js.map